import styled from "styled-components";
import { rhythm, scale } from "../utils/typography";

const Block = styled.section`
  display: flex;
  flex-flow: wrap;
  flex-direction: row;

  .animation-up-to-down {
    animation-duration: 2s;
    animation-name: slideUpToDown;
  }

  @keyframes slideUpToDown{
    from {
      margin-top: -50px;
      color: #ededed !important;
    }

    to {
      margin-top: 40px;
      color: #222 !important;
    }
  }


  @media screen and (max-width: 768px) {
    flex-direction: column !important;
  }


  .white-paragraph {
    @media (min-width: 769px){
      margin-top: 75px;
    }

    @media (min-width: 1024px){
      margin-top: 3rem;
    }

    @media (min-width: 1260px){
      margin-top: 5%;
      margin-bottom: 1%;
    }

    @media (min-width: 1600px){
      margin-top: 13%;
      margin-bottom: 3%;
    }
    
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .col {
      width: 50%;
    }
  }

  @media (max-width: 768px){

    .white-paragraph {
      display: flex;
      flex-direction: column;

      .col {
        width: 100%;
      }

      .picture {
        margin-top: -50px;
        margin-bottom: 33px;
      }
  }
  }

  hr {
    width: 20%;
    height: 4px;
    background: #333;
  }
  .paragraph,
  .list {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: ${rhythm(3.5)} 5vw ${rhythm(3)};

    @media (min-width: 1260px){
      padding: ${rhythm(3.5)} 5vw 8%;
    }
  }

  .list .item .title h2{
    font-weight: bold;
    font-family: 'Roboto' !important; 
  }

  .list-white {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: ${rhythm(3.5)} 5vw ${rhythm(3)};
  }
  @media (min-width: 768px){
      .list {
          text-align: center;
      }

      .list-white {
          text-align: center;

          .hr-white-list {
            background: #999999;
          }
      }
  }

  .map-separator{
    position: relative;
    width: 100%;
    height: 1px;
    top: 132px;
    margin: 0;
    display: none;
    background-color: #ccc;
    @media (min-width: 768px){
      display: block;
    }
  }

  @media (max-width: 768px){
    
    .list{
      padding: 3.6rem 5vw 4.8rem !important;
    }
    .list-white{
      padding: 3.6rem 5vw 4.8rem !important;
    }
  }
  .list {

    @media (min-width: 768px ){
      padding-left: 200px;
      padding-right: 200px;
    }

    .item {
      margin-bottom: 0px;
      margin-top: 40px;
    }
    .icon {
      font-size: 50px;
      margin-bottom: ${rhythm(1)};
    }
    hr {
      width: 50px;
      background: #999999;
      margin-top: 15px;
      @media (min-width: 768px){
        margin: auto;
        margin-bottom: 20px;
        margin-top: 20px;
      }
    }
  }
  .list{
    background: #ededed;
  }
  .list-white{
    background: #fff;
  }
  .paragraph {
    
    .map {
      max-width: 400px;
    }
    .title.big {
      h1 {
        ${scale(1.25)}
        line-height: 1;
        font-family: 'Roboto' !important;
        @media (max-width: 768px){
          margin-top: 50px;
        }
      }
    }
  }
`;

export default Block;